import { useQuery } from "@tanstack/react-query";

import { ITestInfoRes } from "../models";
import { getTopicTestInfo } from "../queries";
import { topicTestsConst } from "..";

export const useTopicTestInfo = (testId: number | undefined) =>
  useQuery<ITestInfoRes>({
    queryKey: [topicTestsConst.queryKeys.USE_TOPIC_TEST_INFO, testId],
    queryFn: () => getTopicTestInfo(testId),
    enabled: !!testId
  });
